module.exports = __webpack_public_path__ + "img/arrow_down_circle.e9b7f683.svg";